$('.tab').find('li').on('click', function () {
  let idx = $('.tab li').index(this);
  $('.tab li').removeClass('current');
  $(this).addClass('current');
  $(this).parent().next('.tab-content').find('.item').removeClass('current');
  $('.tab-content').find('.item').eq(idx).addClass('current');
});

